import {ReactNode} from "react"
import {Stack} from "@mui/joy"
import {ResponsiveStyleValue} from "@mui/system"

export type PageContainerProps = {
    children: ReactNode
    /** Width from the `md` breakpoint up; below it a page always spans the screen */
    width: { md: string, lg: string }
    gap?: ResponsiveStyleValue<number>
}

/**
 * The column every page is laid out in.
 *
 * Pages used to set a width from `md` up and nothing below, so on a phone they shrank to whatever
 * their content happened to need, inside a 32px padding the screen had no room for. Below `md` the
 * column now takes the whole width, with a gutter sized for a phone.
 */
const PageContainer = ({children, width, gap = 2}: PageContainerProps) =>
    <Stack gap={gap}
           boxSizing={"border-box"}
           width={{xs: "100%", md: width.md, lg: width.lg}}
           maxWidth={"100%"}
           paddingX={{xs: 2, sm: 3, md: 4}}
           paddingY={{xs: 2.5, md: 4}}>
        {children}
    </Stack>

export default PageContainer
